import { render, staticRenderFns } from "./report-main.vue?vue&type=template&id=1ff86b86&scoped=true"
import script from "./report-main.vue?vue&type=script&lang=js"
export * from "./report-main.vue?vue&type=script&lang=js"
import style0 from "./report-main.vue?vue&type=style&index=0&id=1ff86b86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ff86b86",
  null
  
)

export default component.exports